import React from "react";
import Image from "next/image";
import { TopShape, CPLBanner } from "@assets/icons";

function ApplyNowBanner() {
    return (
        <section className="relative bg-[#f2f2f2] min-h-[500px] overflow-hidden mt-20 2xl:min-h-[415px]">
            {/* Content Container */}
            <div className="relative z-10 max-w-[1920px] mx-auto px-4 sm:px-8 2xl:px-[80px]">
                {/* Text + Image Layout */}
                <div className="flex flex-col items-center text-center gap-4 pt-1 2xl:flex-row 2xl:items-start 2xl:justify-evenly 2xl:text-left 2xl:pl-[185px]">
                    {/* Text Content */}
                    <div className="space-y-4 max-w-[287px] lg:max-w-[560px] 2xl:max-w-[600px] 2xl:pt-[40px] 2xl:pl-[20px]">
                        <h1 className="text-left text-[25px] w-[301px] sm:w-full h-[40px] lg:w-full lg:h-auto leading-[40px] font-bold text-[#212459] uppercase 2xl:leading-[50px] 2xl:w-[472px] 2xl:h-[48px] 2xl:text-[44px]">
                            We are here to help
                        </h1>
                        <p className="w-[287px] sm:w-full h-[88px] lg:w-full lg:h-auto text-[18px] leading-[29px] text-black text-left 2xl:w-[738px] 2xl:h-[120px] 2xl:text-[24px] ">
                            It’s time to make your financial dreams come true. ClearPath Lending will be with you every
                            step of the way.
                        </p>
                    </div>

                    {/* Image */}
                    <div className="mt-4 2xl:mr-0 2xl:mt-0">
                        <Image
                            src={CPLBanner}
                            alt="Apply Now page banner illustration"
                            width={460}
                            height={369}
                            className="w-[310px] h-[242px] 2xl:w-[445px] 2xl:h-[357px]"
                        />
                    </div>
                </div>
            </div>

            {/* Bottom Wave Shape */}
            <div className="absolute bottom-0 left-0 w-full z-0">
                <Image
                    src={TopShape}
                    alt=""
                    aria-hidden="true"
                    width={1592}
                    height={312}
                    className="w-full h-[151px] object-fill"
                />
            </div>
        </section>
    );
}

export default ApplyNowBanner;
